import './main.scss';

import Alpine from 'alpinejs';
import Swiper from 'swiper/bundle';

window.Alpine = Alpine;
window.Swiper = Swiper;

import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import anchor from '@alpinejs/anchor';
import intersect from '@alpinejs/intersect';

import './js/product';
import './js/cart';

// Hero Slideshow Swiper
Alpine.data('hero_slideshow', () => ({
  init() {
    new Swiper('.swiper-slideshow', {
      direction: 'horizontal',
      initialSlide: 0,
      loop: false,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  },
}));

// Featured Collection Slider Swiper
Alpine.data('feat_collection_slider', () => ({
  init() {
    new Swiper('.swiper_feat_collection_slider', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next-col',
        prevEl: '.swiper-button-prev-col',
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
        },
      },
    });
  },
}));
// Featured Collection Slider Swiper
Alpine.data('feat_collection_list_slider', () => ({
  init() {
    new Swiper('.swiper_feat_collection_list_slider', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
        },
      },
    });
  },
}));
// Featured Products (bundles) Slider Swiper
Alpine.data('feat_products_slider', () => ({
  init() {
    new Swiper('.swiper_feat_products_slider', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
        },
      },
    });
  },
}));

// Collection MobileXS Slider Swiper
Alpine.data('swiper_tiny_collection', () => ({
  init() {
    new Swiper('.swiper-tiny-collection', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 8,
    });
  },
}));
//  Collection Desktop Slider Swiper
Alpine.data('swiper_desktop_collection', () => ({
  init() {
    new Swiper('.swiper_desktop_collection', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 20,
      breakpoints: {
        1440: {
          slidesPerView: 5,
        },
      },
    });
    setTimeout(() => {
      document.querySelector('.swiper_desktop_collection').classList.remove('opacity-0');
    }, 350);
  },
}));

Alpine.data('hoverVideo', () => ({
  video: null,
  observer: null,
  currentlyPlaying: null,
  init() {
    this.playVideo();
    window.addEventListener('resize', () => {
      this.playVideo();
    });
  },
  playVideo() {
    this.video = this.$el;
    if (window.innerWidth < 768) {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.currentlyPlaying && this.currentlyPlaying !== this.video) {
                this.currentlyPlaying.pause();
              }
              this.video.play();
              this.currentlyPlaying = this.video;
            } else {
              this.video.pause();
              if (this.currentlyPlaying === this.video) {
                this.currentlyPlaying = null;
              }
            }
          });
        },
        { threshold: 0.5 }
      );
      this.observer.observe(this.video);
      return;
    }

    this.video.autoplay = false;
    this.video.currentTime = 1;
    if (this.video.classList.contains('banner-video')) {
      this.video.play();
    }

    const sliderContainer = this.$el.closest('.swiper-slide');
    sliderContainer.addEventListener('mouseover', ($event) => {
      this.video.play();
    });

    sliderContainer.addEventListener('mouseout', ($event) => {
      this.video.pause();
    });
  },
}));

Alpine.data('scalableSection', () => ({
  init() {
    const section = this.$el;
    const scaleStartThreshold = 60;
    const minScale = 0.6;
    const maxScale = 1;

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;
      const scrolledPercentage = (Math.max(0, scrollY - sectionTop) * 100) / sectionHeight;
      if (scrolledPercentage >= 100) {
        section.style.transform = `scale(${minScale})`;
        return;
      }

      if (scrolledPercentage < scaleStartThreshold) {
        section.style.transform = `scale(${maxScale})`;
        return;
      }

      const difference = scrolledPercentage - scaleStartThreshold;
      const scale = minScale + (maxScale - minScale) * (1 - difference / (100 - scaleStartThreshold));
      section.style.transform = `scale(${scale})`;
    });
  },
}));

Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(anchor);
Alpine.plugin(intersect);

Alpine.start();
